import DashboardSubnav from 'components/Dashboard/DashboardComponent/DashboardSubnav';
import DashboardUpdateComponent from 'components/Dashboard/DashboardComponent/DashboardUpdateComponent';
import LeftComponent from 'components/Dashboard/DashboardComponent/LeftComponent';
import SnapshotComponent from 'components/Dashboard/DashboardComponent/SnapshotComponent';
import useCallCollectContent from 'components/Dashboard/hooks/useCallCollectContent';
import useAddMetaTags from 'components/Dashboard/utilities/addMetaTags';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';

const DashboardComponent = () => {
  const [updatePanelState, setUpdatePanelState] = useState({ open: false, url: null });
  const [transitionFinishes, setTransitionFinishes] = useState(false);
  const { open } = updatePanelState;
  const updateState = { updatePanelState, setUpdatePanelState };
  const { addMetaTags } = useAddMetaTags();
  const { callCollectContent } = useCallCollectContent();

  const location = useLocation();
  const navigate = useNavigate();
  const { date } = useParams();

  const initialCall = useRef(null);
  initialCall.current = () => {
    const title = `Dashboard - PolicyMogul`;
    addMetaTags({ title });
    callCollectContent({
      requestProperties: {
        eventName: 'DashboardView',
        url: `${window.location.origin}${location.pathname}${location.search}${location.hash}`,
      },
    });
  };

  useEffect(() => {
    initialCall.current();
  }, []);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setTransitionFinishes(true);
      }, 200);
    } else {
      setTransitionFinishes(false);
    }
  }, [open]);

  const resetEventParameter = (props) => {
    const { search } = props ?? {};
    const searchParams = new URLSearchParams(search ?? window.location.search);
    searchParams.delete('in');
    navigate({ search: searchParams?.toString() }, { replace: true });
  };

  return (
    <div className='dashboard-root-container'>
      <DashboardSubnav updateState={updateState} />
      <div className='flex-grow-1 main-content-wrapper mx-auto '>
        <div className='pt-4 pt-lg-5 h-100 px-3 px-md-4 px-lg-5 '>
          <div className='h-100 flex-centered flex-nowrap overflow-hidden position-relative'>
            <LeftComponent updateState={updateState} resetEventParameter={resetEventParameter} date={date} />

            <div
              className={`dashboard-panel-briefing ${open ? 'open px-0 px-lg-3' : 'close-panel pl-lg-3 pr-0'} h-100`}
            >
              <SnapshotComponent updateState={updateState} resetEventParameter={resetEventParameter} date={date} />
            </div>
            <div className={`dashboard-panel-update d-none d-lg-block h-100 ${open ? `open` : ''}`}>
              <DashboardUpdateComponent
                updateState={updateState}
                transitionFinishes={transitionFinishes}
                resetEventParameter={resetEventParameter}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardComponent;
